import React, { Component } from 'react';
import './HostNewGameOnlineForm.css';

export class JoinOnlineByCodeForm extends Component {
    static displayName = "Join online session";

  constructor(props) {
      super(props);

      this.forwardToJoinWithCode = this.forwardToJoinWithCode.bind(this);
      
      this.state = { statusText: "", code: "" };
  }

  render() {
    return (
        <div className="container">
            <div>
                <label>Enter 8 digit code to join game</label>
                <input value={this.state.code} type="text" pattern="[0-9a-g]{8}" onChange={x => this.setState({ code: x.target.value })} />
                <button className={"btn btn-primary"} onClick={async () => await this.forwardToJoinWithCode()}>Join</button>
                <label>{this.state.statusText}</label>
            </div>
        </div>
        );
    }

    async forwardToJoinWithCode() {
        var code = this.state.code;
        if (code === "" || code.length != 8) {
            this.setState({ statusText: "Code must be 8 characters" });
            return;
        }

        const response = await fetch('session/joincode/' + code);

        if (!response.ok) {
            this.setState({ statusText: "Game not found or not accepting players: " + response.statusText });
            return;
        }

        const data = await response.json();

        var sessionId = data.gameSessionId;

        window.location = '/join-game-online/' + sessionId;;
    }
}
